import { Observable } from 'rxjs';
import {
  CreateExpensePayload,
  Expense,
  ExpenseDriverOption,
  ExpenseRef,
  ExpenseStatusChangePayload,
  ExpensesPage,
  ExpensesQuery,
  UpdateExpensePayload,
} from '../models/expense.model';

/**
 * Frontera de datos del módulo de Gastos.
 *
 * Los componentes dependen sólo de esta clase abstracta; `ExpensesModule` decide
 * si la implementación es la HTTP real o la mock en memoria según
 * `environment.features.expensesMock`.
 */
export abstract class ExpensesDataSource {
  /** Filtrado, orden y paginación se resuelven en servidor. */
  abstract list(query: ExpensesQuery): Observable<ExpensesPage>;

  /**
   * Todos los resultados que cumplen los filtros, sin paginar.
   *
   * No hay endpoint de export en la API, así que se compone iterando páginas.
   */
  abstract listAll(query: ExpensesQuery): Observable<Expense[]>;

  /** Vuelve a leer una fila tras un cambio de estado (el PATCH no devuelve cuerpo). */
  abstract getOne(ref: ExpenseRef): Observable<Expense>;

  abstract create(payload: CreateExpensePayload): Observable<Expense>;

  abstract update(
    ref: ExpenseRef,
    payload: UpdateExpensePayload
  ): Observable<Expense>;

  /** Aprobar, rechazar o volver a pendiente. */
  abstract changeStatus(
    ref: ExpenseRef,
    payload: ExpenseStatusChangePayload
  ): Observable<void>;

  /** Borra un gasto creado por error. El comprobante se queda en el almacén. */
  abstract remove(ref: ExpenseRef): Observable<void>;

  abstract searchDrivers(searchTerm?: string): Observable<ExpenseDriverOption[]>;
}
